/**
 * The type of resource to grant access to
 */
export enum ResourceType {
  /** Grant a user/apiKey/team access to a specific data silo */
  DataSilo = 'dataSilo',
  /** A datapoint is a specific route(s) for a data silo */
  DataPoint = 'dataPoint',
}
